import { axiosMM } from "./axiosCreator";

/**
 * Abre uma conexão stateless de longo período para a rota informada e a mantém
 * aberta até receber a informação isCompleted como true ou expirar
 * 
 * @param {string} url api url
 * @param {object} headers request headers
 * @param {string} authToken request with auth token
 * @param {number} interval seconds of interval to do another request
 * 
 * @returns {Promise}
 */
export const createPollingRequest = ({ url, headers = {}, authToken = '', timeoutInSeconds = 60 }) => {
    return new Promise((resolve, reject) => {
        let keepAlive = true;
		let lifetime = null;

        lifetime = setTimeout(() => {
            keepAlive = false;
        }, (timeoutInSeconds * 1000));

        const poll = () => {
            axiosMM.get(
                url,
                { headers: { ...headers, authorization: authToken } })
                .then((response) => {
                if (keepAlive) {
                    if (!!response?.data?.isCompleted) {
                        if (lifetime) clearTimeout(lifetime);

                        resolve(response.data);
                    } else {
                        poll();
                    }
                } else {
                    resolve({ isCompleted: false });
                }
            })
            .catch(() => {
                if (lifetime) clearTimeout(lifetime);
                
                console.error("Error trying to retrieve server response");
                reject({ status: 'error' });
            });
        }

        poll();
    });
};